import { Feature } from '../analytics';
import { deliverChatbotMessage } from '../chatbot/chatbot.util';
import { getChatbotFlexMessage } from '../chatbot/flex/utils';
import { generateReplicantChatbotPayload } from '../chatbot/messageTemplates';
import { getLocale } from '../getters/user';
import type { State } from '../State';
import { createReportableError } from '../utils/errors';
import type { SyncActionAPI } from '../utils/types';
import { catalog } from './component/iap.catalog';
import type { ProductId } from './iap.ruleset';

export function sendPurchaseConfirmationOA(
  state: State,
  args: { productId: ProductId; purchaseID: string },
  api: SyncActionAPI,
): void {
  const { productId, purchaseID } = args;
  const locale = getLocale(state) === 'en' ? 'en' : 'ja';
  const itemName = catalog[productId].title[locale];

  try {
    const message = getChatbotFlexMessage({
      template: 'purchaseConfirmation',
      payload: generateReplicantChatbotPayload({
        feature: Feature.IAP._,
        $subFeature: Feature.IAP.PURCHASE_CONFIRMATION_OA,
        productID: productId,
        purchaseID,
      }),
      data: { itemName, locale },
    });

    deliverChatbotMessage(state, api, {
      receiverId: state.id,
      message,
      channel: 'oa',
    });
  } catch (error) {
    const reportableError =
      error instanceof Error ? error : new Error(String(error));
    api.reportError(createReportableError('error', reportableError), {
      productId,
      purchaseID,
    });
  }
}
